import { motion } from 'framer-motion';

export const NewsletterSection = ({ email, setEmail, subscribing, onSubmit }) => (
  <section className="py-24 bg-zinc-950 border-t border-zinc-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-red-600 p-10 sm:p-16 relative overflow-hidden"
      >
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'repeating-linear-gradient(45deg, #fff 0, #fff 1px, transparent 1px, transparent 60px)' }} />
        <div className="relative z-10 max-w-xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3 tracking-tight">
            Stay Ahead of the Market
          </h2>
          <p className="text-red-100 mb-8" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            Get weekly freight market insights, rate trends, and logistics tips straight to your inbox.
          </p>
          <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-4 py-3.5 bg-white/15 border border-white/30 text-white placeholder-white/50 focus:border-white focus:bg-white/20 outline-none text-sm transition-colors"
              data-testid="newsletter-email"
            />
            <button
              type="submit"
              disabled={subscribing}
              className="bg-white text-red-600 px-6 py-3.5 font-bold uppercase tracking-wider text-sm hover:bg-zinc-100 transition-colors disabled:opacity-50"
              data-testid="newsletter-submit"
            >
              {subscribing ? 'Sending...' : 'Subscribe'}
            </button>
          </form>
          <p className="text-red-200/60 text-xs mt-4" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            No spam. Unsubscribe anytime. We respect your inbox.
          </p>
        </div>
      </motion.div>

      {/* Footer brand */}
      <div className="mt-24 text-center overflow-hidden">
        <div className="text-[8vw] font-black text-zinc-900 leading-none tracking-tighter select-none" aria-hidden="true">
          RED BALL EXPRESS
        </div>
      </div>
    </div>
  </section>
);
